import { Fragment } from 'react/jsx-runtime';
import { cn } from './utils';

export const KimIconDark = ({ className }: { className?: string }) => {
  return (
    <Fragment>
      <svg
        viewBox="0 0 117 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className} shine-effect`}
      >
        <path
          d="M20.3501 22.5669C25.6046 27.079 22.8266 31.7357 20.7808 33.5L6.99867 22.3934C1.99766 18.1331 4.34247 13.588 6.60775 11.5253L20.3501 22.5669Z"
          fill="white"
        />
        <path
          d="M20.3501 10.9331C25.6046 6.42099 22.8266 1.76429 20.7808 -4.83179e-05L6.99867 11.1066C1.83036 15.4452 4.41451 20.1308 6.56797 22.0397L20.3501 10.9331Z"
          fill="#FABF01"
        />
        <path
          d="M69.3049 8.60547C71.4266 8.60547 73.1466 10.3255 73.1466 12.4472V29.6582C73.1466 31.7799 71.4266 33.5 69.3049 33.5C67.1831 33.5 65.4631 31.78 65.4631 29.6582V12.4472C65.4631 10.3255 67.1831 8.60547 69.3049 8.60547Z"
          fill="white"
        />
        <ellipse
          cx="69.3562"
          cy="3.68807"
          rx="3.83008"
          ry="3.68807"
          fill="#FABF01"
        />
        <path
          d="M78.0642 33.5002V8.62227H85.0523V13.0115H85.3621C85.9129 11.5538 86.8309 10.4039 88.1161 9.56167C89.4013 8.71945 90.9389 8.29834 92.7289 8.29834C94.5419 8.29834 96.0853 8.72485 97.359 9.57787C98.6327 10.4201 99.4818 11.5646 99.9064 13.0115H100.182C100.721 11.5862 101.696 10.4471 103.108 9.59406C104.531 8.73025 106.212 8.29834 108.151 8.29834C110.618 8.29834 112.62 9.03798 114.158 10.5173C115.707 11.9858 116.482 14.0697 116.482 16.7691V33.5002H109.166V18.1296C109.166 16.7475 108.776 15.711 107.996 15.0199C107.216 14.3289 106.24 13.9833 105.07 13.9833C103.739 13.9833 102.7 14.3828 101.955 15.1819C101.209 15.9701 100.836 17.0121 100.836 18.3078V33.5002H93.7272V17.9839C93.7272 16.7637 93.3543 15.7919 92.6084 15.0685C91.8741 14.3451 90.9044 13.9833 89.6996 13.9833C88.8849 13.9833 88.1505 14.1777 87.4964 14.5664C86.8539 14.9443 86.3432 15.4788 85.9646 16.1699C85.5859 16.8501 85.3966 17.6491 85.3966 18.567V33.5002H78.0642Z"
          fill="white"
        />
        <path
          d="M43.2408 26.3363L43.258 18.0544H44.329L52.8275 8.6055H61.2741L49.8565 21.1176H48.1118L43.2408 26.3363ZM36.5732 33.5V0H43.9317V33.5H36.5732ZM53.1557 33.5L45.3481 22.6573L50.2537 17.7789L61.7751 33.5H53.1557Z"
          fill="white"
        />
      </svg>
      <style>{`
        .shine-effect {
          transition: fill 0.3s ease;
        }

        .shine-effect:hover {
          filter: brightness(1.2); /* Adjust brightness for shine effect */
        }
      `}</style>
    </Fragment>
  );
};

export const KimIconLight = ({ className }: { className?: string }) => {
  return (
    <Fragment>
      <svg
        viewBox="0 0 117 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className} shine-effect`}
      >
        <path
          d="M20.6094 22.5669C25.8639 27.079 23.0859 31.7357 21.0401 33.5L7.25794 22.3934C2.25693 18.1331 4.60175 13.588 6.86702 11.5253L20.6094 22.5669Z"
          fill="#085454"
        />
        <path
          d="M20.6094 10.9331C25.8639 6.42099 23.0859 1.76429 21.0401 -4.83179e-05L7.25794 11.1066C2.08964 15.4451 4.67379 20.1308 6.82725 22.0397L20.6094 10.9331Z"
          fill="url(#paint0_linear_192_42)"
        />
        <path
          d="M69.5642 8.60547C71.6859 8.60547 73.4059 10.3255 73.4059 12.4472V29.6582C73.4059 31.7799 71.6859 33.5 69.5642 33.5C67.4424 33.5 65.7224 31.78 65.7224 29.6582V12.4472C65.7224 10.3255 67.4424 8.60547 69.5642 8.60547Z"
          fill="#085454"
        />
        <ellipse
          cx="69.6155"
          cy="3.68807"
          rx="3.83008"
          ry="3.68807"
          fill="#FABF01"
        />
        <path
          d="M78.3235 33.5002V8.62227H85.3116V13.0115H85.6214C86.1722 11.5538 87.0902 10.4039 88.3754 9.56167C89.6605 8.71945 91.1981 8.29834 92.9882 8.29834C94.8012 8.29834 96.3446 8.72485 97.6183 9.57787C98.892 10.4201 99.7411 11.5646 100.166 13.0115H100.441C100.98 11.5862 101.956 10.4471 103.367 9.59406C104.79 8.73025 106.471 8.29834 108.41 8.29834C110.877 8.29834 112.88 9.03798 114.417 10.5173C115.966 11.9858 116.741 14.0697 116.741 16.7691V33.5002H109.426V18.1296C109.426 16.7475 109.036 15.711 108.255 15.0199C107.475 14.3289 106.5 13.9833 105.329 13.9833C103.998 13.9833 102.96 14.3828 102.214 15.1819C101.468 15.9701 101.095 17.0121 101.095 18.3078V33.5002H93.9865V17.9839C93.9865 16.7637 93.6136 15.7919 92.8677 15.0685C92.1333 14.3451 91.1637 13.9833 89.9589 13.9833C89.1442 13.9833 88.4098 14.1777 87.7557 14.5664C87.1131 14.9443 86.6025 15.4788 86.2238 16.1699C85.8452 16.8501 85.6558 17.6491 85.6558 18.567V33.5002H78.3235Z"
          fill="#085454"
        />
        <path
          d="M43.5 26.3363L43.5173 18.0544H44.5883L53.0868 8.6055H61.5334L50.1157 21.1176H48.3711L43.5 26.3363ZM36.8325 33.5V0H44.191V33.5H36.8325ZM53.4149 33.5L45.6074 22.6573L50.513 17.7789L62.0343 33.5H53.4149Z"
          fill="#085454"
        />
        <defs>
          <linearGradient
            id="paint0_linear_192_42"
            x1="24.3241"
            y1="2.64646"
            x2="7.95999"
            y2="22.9526"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FBC000" />
            <stop offset="1" stop-color="#ECB400" />
          </linearGradient>
        </defs>
      </svg>
      <style>{`
        .shine-effect {
          transition: fill 0.3s ease;
        }

        .shine-effect:hover {
          filter: brightness(1.2); /* Adjust brightness for shine effect */
        }
      `}</style>
    </Fragment>
  );
};

export const LoadingSpinner = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('animate-spin', className)}
    >
      {/* Three dots circular loader */}
      <circle cx="12" cy="6" r="2" fill="currentColor">
        <animate
          attributeName="r"
          from="2"
          to="2"
          begin="0s"
          dur="1s"
          values="2; 4; 2"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="18" cy="12" r="2" fill="currentColor">
        <animate
          attributeName="r"
          from="2"
          to="2"
          begin="0.2s"
          dur="1s"
          values="2; 4; 2"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="12" cy="18" r="2" fill="currentColor">
        <animate
          attributeName="r"
          from="2"
          to="2"
          begin="0.4s"
          dur="1s"
          values="2; 4; 2"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
};

export const NotFound = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 64 41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>No data</title>
      <g transform="translate(0 1)" fill="none" fill-rule="evenodd">
        <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
        <g fill-rule="nonzero" stroke="#d9d9d9">
          <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
          <path
            d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
            fill="#fafafa"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const KimLogoCollapsed = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Vector">
        <path
          d="M20.2567 22.9036C26.7212 27.4831 23.3035 32.2093 20.7866 34L3.83035 22.7275C-2.3224 18.4036 0.56243 13.7906 3.3494 11.6971L20.2567 22.9036Z"
          fill="#085454"
        />
        <path
          d="M20.3308 11.0964C26.7953 6.51691 23.3776 1.79068 20.8606 0L3.90444 11.2725C-2.45414 15.6758 0.273143 20.8636 3.37456 22.3689L20.3308 11.0964Z"
          fill="url(#paint0_linear_138_8)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_138_8"
          x1="24.9009"
          y1="2.68612"
          x2="9.22849"
          y2="26.2607"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBC000" />
          <stop offset="1" stop-color="#ECB400" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const KimLogoCollapsedDark = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 33 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Vector">
        <path
          d="M27.0677 30.3136C35.687 36.3747 31.1301 42.63 27.7742 45L5.16605 30.0805C-3.03756 24.3577 0.808859 18.2523 4.52479 15.4815L27.0677 30.3136Z"
          fill="white"
        />
        <path
          d="M27.1665 14.6864C35.7858 8.62532 31.2289 2.37002 27.873 0L5.26484 14.9195C-3.2132 20.7474 0.423146 27.6136 4.55834 29.6058L27.1665 14.6864Z"
          fill="url(#paint0_linear_1211_799)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1211_799"
          x1="33.2599"
          y1="3.55516"
          x2="12.5767"
          y2="34.8976"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBC000" />
          <stop offset="1" stop-color="#ECB400" />
        </linearGradient>
      </defs>
    </svg>
  );
};
